<script setup lang="ts">
import IconDescriptionElement from '~/components/ui/Sections/IconDescriptionElement.vue'

type Props = {
  value: number
}

const props = defineProps<Props>()

const formattedValue = computed<number>(() => Math.round(props.value * 100))
</script>

<template>
  <IconDescriptionElement icon-class="fa6-regular:chart-bar">
    <template #title
      >{{ formattedValue }}%
      {{ $t('influencer.profile.slug.about.answerRate00') }}</template
    >
    <template #subtitle>{{
      $t('influencer.profile.slug.about.answerRate01')
    }}</template>
  </IconDescriptionElement>
</template>
